/**
 * Only log message when in development mode.
 */
export const devLog = (message?: any, ...optionalParams: any[]) => {
	if (process.env.NODE_ENV === 'development') {
		// console.log(message, ...optionalParams);
	}
};
